import v from "@babel/runtime/helpers/esm/objectSpread2";
import I from "@babel/runtime/helpers/esm/classCallCheck";
import D from "@babel/runtime/helpers/esm/createClass";
import u from "@babel/runtime/helpers/esm/assertThisInitialized";
import W from "@babel/runtime/helpers/esm/inherits";
import B from "@babel/runtime/helpers/esm/createSuper";
import p from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as M } from "@semcore/utils/lib/core/index";
import F, { sstyled as h, Component as H, assignProps as S } from "@semcore/core";
import a from "react";
import { ScreenReaderOnly as $, Box as x } from "@semcore/flex-box";
import U from "@semcore/modal";
import K from "@semcore/icon/Check/m";
import L from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import O from "@semcore/utils/lib/enhances/i18nEnhance";
import { localizedMessages as k } from "./translations/__intergalactic-dynamic-locales.mjs";
import { setFocus as j } from "@semcore/utils/lib/use/useFocusLock";
import q from "@semcore/utils/lib/uniqueID";
import m from "@semcore/button";
import G from "@semcore/icon/ArrowRight/m";
import J from "@semcore/icon/ArrowLeft/m";
var Q = (
  /*__reshadow_css_start__*/
  (M.insert(
    /*__inner_css_start__*/
    ".___SWizard_n61tb_gg_{max-width:980px;max-height:700px;display:flex;padding:0;background:0 0}.___SSidebar_n61tb_gg_{background:var(--intergalactic-control-primary-advertising, #5925ab);color:var(--intergalactic-text-primary-invert, #ffffff);font-weight:var(--intergalactic-bold, 700);font-size:var(--intergalactic-fs-300, 16px);line-height:var(--intergalactic-lh-300, 150%);padding:var(--intergalactic-spacing-10x, 40px) var(--intergalactic-spacing-2x, 8px) calc(var(--intergalactic-spacing-8x, 32px) + var(--intergalactic-spacing-05x, 2px));max-width:220px;flex-shrink:0;box-sizing:border-box;border-radius:var(--intergalactic-modal-rounded, 12px)0 0 var(--intergalactic-modal-rounded, 12px)}@media (max-width:1060px){.___SSidebar_n61tb_gg_{width:44px}}.___SSidebarHeader_n61tb_gg_{font-size:var(--intergalactic-fs-300, 16px);margin:0 var(--intergalactic-spacing-5x, 20px) var(--intergalactic-spacing-4x, 16px)}@media (max-width:1060px){.___SSidebarHeader_n61tb_gg_{display:none}}.___SStepper_n61tb_gg_{display:flex;font-size:var(--intergalactic-fs-200, 14px);border-radius:var(--intergalactic-control-rounded, 6px);padding:var(--intergalactic-spacing-2x, 8px) var(--intergalactic-spacing-3x, 12px);cursor:pointer;position:relative;overflow:auto;line-height:var(--intergalactic-lh-200, 142%)}@media (hover:hover){.___SStepper_n61tb_gg_:hover{background:var(--intergalactic-control-primary-advertising-hover, #421983);z-index:1}}.___SStepper_n61tb_gg_.__active_n61tb_gg_{background:var(--intergalactic-control-primary-advertising-active, #8649e1)}.___SStepper_n61tb_gg_.__disabled_n61tb_gg_,.___SStepper_n61tb_gg_:disabled{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}@media (max-width:1060px){.___SStepper_n61tb_gg_{padding:var(--intergalactic-spacing-2x, 8px) var(--intergalactic-spacing-1x, 4px)}@media (hover:hover){.___SStepper_n61tb_gg_:hover{width:-moz-fit-content;width:fit-content;max-width:220px}.___SStepper_n61tb_gg_:hover .___SStepDescription_n61tb_gg_{display:block;border-radius:var(--intergalactic-control-rounded, 6px);white-space:nowrap;overflow:auto}.___SStepper_n61tb_gg_.__active_n61tb_gg_:hover .___SStepDescription_n61tb_gg_{background:var(--intergalactic-control-primary-advertising-active, #8649e1)}}}.___SStepNumber_n61tb_gg_{display:inline-block;min-width:20px}.___SCompleted_n61tb_gg_{margin-top:1px}@media (max-width:1060px){.___SStepDescription_n61tb_gg_{display:none}}.___SContent_n61tb_gg_{padding:var(--intergalactic-spacing-10x, 40px);width:100%;border-radius:0 var(--intergalactic-modal-rounded, 12px) var(--intergalactic-modal-rounded, 12px)0;background:var(--intergalactic-bg-primary-neutral, #ffffff)}.___SSidebarMenu_n61tb_gg_{display:contents}",
    "n61tb_gg_"
  ), {
    __SWizard: "___SWizard_n61tb_gg_",
    __SStepNumber: "___SStepNumber_n61tb_gg_",
    __SCompleted: "___SCompleted_n61tb_gg_",
    __SContent: "___SContent_n61tb_gg_",
    __SSidebarMenu: "___SSidebarMenu_n61tb_gg_",
    __SSidebar: "___SSidebar_n61tb_gg_",
    __SSidebarHeader: "___SSidebarHeader_n61tb_gg_",
    __SStepper: "___SStepper_n61tb_gg_",
    _active: "__active_n61tb_gg_",
    _disabled: "__disabled_n61tb_gg_",
    __SStepDescription: "___SStepDescription_n61tb_gg_"
  })
), f = /* @__PURE__ */ function(e) {
  W(t, e);
  var _ = B(t);
  function t() {
    var r;
    I(this, t);
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    return r = _.call.apply(_, [this].concat(i)), p(u(r), "_steps", /* @__PURE__ */ new Map()), p(u(r), "modalRef", /* @__PURE__ */ a.createRef()), p(u(r), "contentRef", /* @__PURE__ */ a.createRef()), p(u(r), "state", {
      highlighted: null
    }), p(u(r), "stepperRefs", []), p(u(r), "stepperFocusPrev", function(c) {
      return function() {
        var o = r._steps.get(c);
        o && (r.setState({
          highlighted: o == null ? void 0 : o.step
        }), setTimeout(function() {
          var l;
          (l = r.stepperRefs[c - 1]) === null || l === void 0 || l.focus();
        }, 0));
      };
    }), p(u(r), "stepperFocusNext", function(c) {
      return function() {
        var o = r._steps.get(c + 2);
        o && (r.setState({
          highlighted: o == null ? void 0 : o.step
        }), setTimeout(function() {
          var l;
          (l = r.stepperRefs[c + 1]) === null || l === void 0 || l.focus();
        }, 0));
      };
    }), r;
  }
  return D(t, [{
    key: "getStepProps",
    value: function(n) {
      return {
        steps: this._steps,
        active: n.step === this.asProps.step,
        id: "".concat(this.asProps.uid, "-step-").concat(n.step)
      };
    }
  }, {
    key: "getSidebarProps",
    value: function() {
      return {
        uid: this.asProps.uid
      };
    }
  }, {
    key: "getContentProps",
    value: function() {
      return {
        uid: this.asProps.uid,
        step: this.asProps.step,
        ref: this.contentRef
      };
    }
  }, {
    key: "getStepBackProps",
    value: function() {
      return {
        getI18nText: this.asProps.getI18nText,
        step: this.asProps.step
      };
    }
  }, {
    key: "getStepNextProps",
    value: function() {
      return {
        getI18nText: this.asProps.getI18nText,
        step: this.asProps.step
      };
    }
  }, {
    key: "getStepperProps",
    value: function(n, i) {
      var s = this, c = i + 1;
      if (this._steps.has(n.step)) {
        var o = this._steps.get(n.step);
        c = o.number;
      } else
        this._steps.set(n.step, v({
          number: c
        }, n));
      var l = n.step === this.asProps.step, d = this.state.highlighted === n.step || this.state.highlighted === null && i === 0;
      return {
        active: l,
        tabIndex: d ? 0 : -1,
        number: c,
        getI18nText: this.asProps.getI18nText,
        uid: this.asProps.uid,
        ref: function(b) {
          s.stepperRefs[i] = b;
        },
        focusNext: this.stepperFocusNext(i),
        focusPrev: this.stepperFocusPrev(i)
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      var i = this;
      n.step !== this.asProps.step && (this.setState({
        highlighted: this.asProps.step || null
      }), setTimeout(function() {
        n.step !== i.asProps.step && j(i.contentRef.current);
      }, 1));
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.Root, s = this.asProps, c = s.Children, o = s.styles, l = s.uid;
      return this._steps.clear(), n = h(o), /* @__PURE__ */ a.createElement(i, n.cn("SWizard", {
        render: U,
        "aria-label": void 0,
        ref: this.modalRef,
        "aria-labelledby": "".concat(l, "-title")
      }), /* @__PURE__ */ a.createElement(c, n.cn("Children", {})));
    }
  }]), t;
}(H);
p(f, "displayName", "Wizard");
p(f, "style", Q);
p(f, "enhance", [O(k), q()]);
p(f, "defaultProps", {
  step: null,
  i18n: k,
  locale: "en"
});
function V(e) {
  var _ = arguments[0], t, r = e.Children, n = e.styles, i = e.title, s = e.uid, c = x, o = "h2", l = "div";
  return a.useCallback(function(d) {
  }, []), t = h(n), /* @__PURE__ */ a.createElement(c, t.cn("SSidebar", v({}, S({
    __excludeProps: ["title"]
  }, _))), i && /* @__PURE__ */ a.createElement(o, t.cn("SSidebarHeader", {
    id: "".concat(s, "-title")
  }), i), /* @__PURE__ */ a.createElement(l, t.cn("SSidebarMenu", {
    role: "tablist",
    "aria-orientation": "vertical"
  }), /* @__PURE__ */ a.createElement(r, t.cn("Children", {}))));
}
function X(e) {
  var _ = arguments[0], t = x, r = e.Children, n = e.styles, i = e.active;
  if (i) {
    var s;
    return s = h(n), /* @__PURE__ */ a.createElement(t, s.cn("SStep", v({}, S({}, _))), /* @__PURE__ */ a.createElement(r, s.cn("Children", {})));
  }
  return null;
}
function w(e) {
  var _ = arguments[0], t, r = e.Children, n = e.styles, i = e.step, s = e.active, c = e.onActive, o = e.completed, l = e.disabled, d = e.number, y = e.getI18nText, b = e.uid, C = e.focusNext, P = e.focusPrev, E = x, N = "span", z = "span", R = K, T = a.useCallback(function(g) {
    c && c(i, g);
  }, [i, c]), A = a.useCallback(function(g) {
    c && (g.key === "Enter" || g.key === " ") && (g.preventDefault(), c(i, g)), g.key === "ArrowUp" && (P(), g.stopPropagation()), g.key === "ArrowDown" && (C(), g.stopPropagation());
  }, [i, c, P, C]);
  return t = h(n), /* @__PURE__ */ a.createElement(E, t.cn("SStepper", v({}, S({
    role: "tab",
    id: "".concat(b, "-stepper-").concat(i),
    "aria-controls": s ? "".concat(b, "-content-").concat(i) : void 0,
    "aria-disabled": l,
    "aria-selected": s,
    onClick: T,
    onKeyDown: A
  }, _))), o && /* @__PURE__ */ a.createElement($, t.cn("ScreenReaderOnly", {}), y("completedStep")), /* @__PURE__ */ a.createElement(N, t.cn("SStepNumber", {
    "aria-hidden": "true"
  }), o ? /* @__PURE__ */ a.createElement(R, t.cn("SCompleted", {})) : d), /* @__PURE__ */ a.createElement(z, t.cn("SStepDescription", {}), /* @__PURE__ */ a.createElement(r, t.cn("Children", {}))));
}
w.enhance = [L()];
function Y(e) {
  var _ = arguments[0], t, r = e.Children, n = e.children, i = e.styles, s = e.uid, c = e.step, o = x;
  return t = h(i), /* @__PURE__ */ a.createElement(o, t.cn("SContent", v({}, S({
    role: "tabpanel",
    "aria-labelledby": "".concat(s, "-stepper-").concat(c),
    id: "".concat(s, "-content-").concat(c)
  }, _))), n ? /* @__PURE__ */ a.createElement(r, t.cn("Children", {})) : stepName);
}
function Z(e) {
  var _ = arguments[0], t, r = m, n = e.Children, i = e.children, s = e.styles, c = e.getI18nText, o = e.stepName, l = a.useCallback(function() {
    var d;
    (d = e.onActive) === null || d === void 0 || d.call(e, e.step - 1);
  }, [e.step]);
  return t = h(s), /* @__PURE__ */ a.createElement(r, t.cn("SStepBack", v({}, S({
    use: "tertiary",
    size: "l",
    onClick: l,
    "aria-label": c("backButton", {
      buttonName: o
    })
  }, _))), /* @__PURE__ */ a.createElement(m.Addon, null, /* @__PURE__ */ a.createElement(J, t.cn("ArrowLeft", {}))), /* @__PURE__ */ a.createElement(m.Text, null, i ? /* @__PURE__ */ a.createElement(n, t.cn("Children", {})) : o));
}
function ee(e) {
  var _ = arguments[0], t, r = m, n = e.Children, i = e.children, s = e.styles, c = e.getI18nText, o = e.stepName, l = a.useCallback(function() {
    var d;
    (d = e.onActive) === null || d === void 0 || d.call(e, e.step + 1);
  }, [e.step]);
  return t = h(s), /* @__PURE__ */ a.createElement(r, t.cn("SStepNext", v({}, S({
    use: "tertiary",
    size: "l",
    onClick: l,
    "aria-label": c("nextButton", {
      buttonName: o
    })
  }, _))), /* @__PURE__ */ a.createElement(m.Text, null, i ? /* @__PURE__ */ a.createElement(n, t.cn("Children", {})) : o), /* @__PURE__ */ a.createElement(m.Addon, null, /* @__PURE__ */ a.createElement(G, t.cn("ArrowRight", {}))));
}
var ye = F(f, {
  Sidebar: V,
  Content: Y,
  Step: X,
  Stepper: w,
  StepBack: Z,
  StepNext: ee
}), Ce = function(_) {
  return _;
};
export {
  ye as default,
  Ce as wrapWizardStepper
};
